import { SideMenuItem } from "../interfaces/config/sideMenu";
import { screens } from "./routes";

const sideMenuDesktop: SideMenuItem[] = [
  { title: "Home", path: "/" },
  { title: "Land for sale", path: screens.lands },
];

/**
 * The array of side menu items for the application.
 * @type {SideMenuItem[]}
 */
export const sideMenu: SideMenuItem[] = sideMenuDesktop;
